import { render, staticRenderFns } from "./BigCategoryCreateOrEdit.vue?vue&type=template&id=28e6ea44&"
import script from "./BigCategoryCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./BigCategoryCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports